import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhomSection() {
  return <section className="py-24 px-6 bg-bg-secondary border-y border-white/5" data-id="element-47">
      <div className="max-w-6xl mx-auto" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-49">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-purple/5 p-8 md:p-12 rounded-2xl border border-brand-purple/20" data-id="element-50">
            <h3 className="text-2xl font-serif text-text-primary mb-8 flex items-center" data-id="element-51">
              <CheckCircle2 className="w-6 h-6 text-brand-purple mr-3" data-id="element-52" />
              Para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-53">
              {['Compras por estrés, cansancio o ansiedad', 'Sientes que tu plata “se diluye” sin darte cuenta', 'Te da rabia llegar apretada a fin de mes', 'Quieres control sin volverte extrema ni tacaña'].map((item, i) => <li key={i} className="flex items-start text-text-secondary" data-id="element-54">
                  <span className="mr-3 text-brand-purple" data-id="element-55">•</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-bg-main p-8 md:p-12 rounded-2xl border border-white/5" data-id="element-56">
            <h3 className="text-2xl font-serif text-text-secondary mb-8 flex items-center" data-id="element-57">
              <XCircle className="w-6 h-6 text-text-muted mr-3" data-id="element-58" />
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-59">
              {['Buscas “hacerte rica” rápido', 'No quieres mirar números ni 15 minutos al día', 'Estás en crisis grave de deuda y necesitas negociación legal específica'].map((item, i) => <li key={i} className="flex items-start text-text-muted" data-id="element-60">
                  <span className="mr-3 text-text-muted" data-id="element-61">•</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}